export const WELCOME_TOU_INLINE_NOTIFICATION_STORAGE_KEY = 'smbDashboardWelcomeTouInlineNotification';
export const CURRENT_WELCOME_TOU_INLINE_NOTIFICATION_VERSION = 'welcome-tou-inline-notification-v1';

const isValidDismissedState = state => typeof state === 'object' && state !== null && !Array.isArray(state);

export const getWelcomeTouInlineNotificationDismissedState = () => {
  try {
    const storedValue = localStorage?.getItem(WELCOME_TOU_INLINE_NOTIFICATION_STORAGE_KEY);
    if (!storedValue) {
      return {};
    }

    const parsedValue = JSON.parse(storedValue);
    return isValidDismissedState(parsedValue) ? parsedValue : {};
  } catch {
    return {};
  }
};

export const hasDismissedWelcomeTouInlineNotification = userKey => {
  if (!userKey) {
    return false;
  }

  const dismissedState = getWelcomeTouInlineNotificationDismissedState();
  return dismissedState[userKey] === CURRENT_WELCOME_TOU_INLINE_NOTIFICATION_VERSION;
};

export const setWelcomeTouInlineNotificationDismissed = userKey => {
  if (!userKey) {
    return false;
  }

  const dismissedState = getWelcomeTouInlineNotificationDismissedState();

  try {
    localStorage?.setItem(WELCOME_TOU_INLINE_NOTIFICATION_STORAGE_KEY, JSON.stringify({
      ...dismissedState,
      [userKey]: CURRENT_WELCOME_TOU_INLINE_NOTIFICATION_VERSION,
    }));
  } catch {
    return false;
  }

  return true;
};
